import { useEffect } from 'react';

import { Spinner, Stack, Text, TextProps, u } from '@ui';

type LoadingScreenProps = {
    message: string;
    typographyVariant?: TextProps['variant'];
    onMount?: (() => void) | (() => Promise<void>);
};

export const LoadingScreen = ({ message, typographyVariant = 'h4', onMount }: LoadingScreenProps) => {
    useEffect(() => {
        onMount?.();
    }, [onMount]);

    return (
        <Stack height="100dvh" width="100%" alignItems="center" justifyContent="center">
            <Stack gap={u(1.5)}>
                <Spinner size="l" />
                {message && <Text variant={typographyVariant}>{message}</Text>}
            </Stack>
        </Stack>
    );
};
